import { Button, Stack } from "@mui/material";

import { ChatMessageWithParts } from "src/views/assistant/types";

type EditTextMenuButtonsProps = {
  chatMessage: ChatMessageWithParts;
  dialogue: ChatMessageWithParts[];
  /** True while the current assistant turn is active (generation + tool execution). */
  isTurnActive?: boolean;
  setIsEditing: (isEditing: boolean) => void;
  setEditedText: (editedText: string) => void;
  handleSaveUserMessage: () => void;
};

const EditTextMenuButtons = ({
  chatMessage,
  dialogue,
  isTurnActive = false,
  setIsEditing,
  setEditedText,
  handleSaveUserMessage,
}: EditTextMenuButtonsProps) => {
  const handleCancelEdit = () => {
    setIsEditing(false);
    const message = dialogue.find((msg) => msg.id === chatMessage.id);
    setEditedText(message?.contentParts[0]?.text ?? "");
  };

  return (
    <Stack direction="row" gap={1}>
      <Button
        color="error"
        variant="text"
        disableElevation
        size="small"
        data-testid="aa-msg-edit-cancel-btn"
        data-attr="assistant:btn:cancel-edit-message"
        onClick={handleCancelEdit}
      >
        Cancel
      </Button>
      <Button
        color="primary"
        variant="contained"
        disableElevation
        size="small"
        data-testid="aa-msg-edit-update-btn"
        data-attr="assistant:btn:save-edited-message"
        disabled={isTurnActive}
        onClick={handleSaveUserMessage}
      >
        Update
      </Button>
    </Stack>
  );
};

export default EditTextMenuButtons;
